<template>
  <el-container class="avue-contail">
    <el-aside :style="{width: isCollapse ? asideWidthCollapse : asideWidth}">
      <!-- 左侧导航栏 -->
      <sidebar class="avue-sidebar"></sidebar>
    </el-aside>
    <el-container>
      <el-header height="auto"
                 class="avue-tabs">
        <!-- 顶部导航栏 -->
        <top />
        <!-- 顶部标签卡 -->
        <tags />
      </el-header>
      <el-main class="avue-main">
        <!-- 主体视图层 -->
        <keep-alive>
          <transition name="fade-transverse">
            <router-view class="avue-view"
                         v-if="$route.meta.keepAlive" />
          </transition>
        </keep-alive>
        <transition name="fade-transverse">
          <router-view class="avue-view"
                       v-if="!$route.meta.keepAlive" />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import tags from './tags'
  import top from './top/'
  import sidebar from './sidebar/'

  export default {
    components: {
      top,
      tags,
      sidebar
    },
    name: 'index',
    data() {
      return {
        // [侧边栏宽度] 正常状态
        asideWidth: '230px',
        // [侧边栏宽度] 折叠状态
        asideWidthCollapse: '65px',
        // 刷新token锁
        refreshLock: false
      }
    },
    created() {
    },
    mounted() { },
    computed: mapGetters(['isLock', 'isCollapse', 'website']),
    props: [],
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .avue-contail {
    height: 100%;
  }
  .avue-sidebar {
    height: 100%;
  }
  .avue-tabs {
    padding: 0;
  }
  .avue-main {
    position: relative;
    padding: 0;
  }
  .avue-view {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .nav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 999;
  }
  .top {
      margin-bottom: 1px;
      height: 36px;
  }
  .top-userImg {
    margin: 0 8px 0 10px;
    padding: 2px;
    border-radius: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #eee;
  }
</style>
